import { MarketServicesClient } from 'online-customer-services-ts'
import { useTranslator } from 'sima-suite-translator-vue3'

import { Service } from '@/core/service/domain/Service.ts'
import { ServiceRepository } from '@/core/service/domain/ServiceRepository.ts'

export class ServiceRepositoryBackendClient implements ServiceRepository {
  private readonly serviceClient: MarketServicesClient

  constructor(url: string) {
    this.serviceClient = new MarketServicesClient(url)
  }

  async getServices(hostId: string): Promise<Service[]> {
    const { language } = useTranslator()
    const services = await this.serviceClient.getMarketServices(hostId, language.value)

    return services.map(
      (service): Service => ({
        category: service.category
          ? {
              id: service.category.id?.toString() ?? '',
              name: service.category.name ?? ''
            }
          : null,
        hasRemarks: service.hasRemarks ?? false,
        id: service.id?.toString() ?? '',
        isSelected: false,
        name: service.name ?? '',
        nextServicesAvailable: service.nextServicesAvailable ?? false,
        remarks: '',
        udt: service.udt ?? 0
      })
    )
  }
}
